import { Injectable } from '@angular/core';
import { UserStateDataEntryValueExcludingUserFirstLogin } from '@osos/shared/api';
import { UserStateExcludingUserFirstLoginPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { UserStateExcludingParserV1Service } from '../../parsers/user-state-excluding-parser/user-state-excluding-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class UserStateExcludingFactoryService extends FactoryBase<
  UserStateDataEntryValueExcludingUserFirstLogin,
  UserStateExcludingUserFirstLoginPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: UserStateExcludingParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  override createPresenterModel(
    model: UserStateDataEntryValueExcludingUserFirstLogin,
  ): UserStateExcludingUserFirstLoginPresenterModel {
    const parser = this.getParser(
      UserStateDataEntryValueExcludingUserFirstLogin,
      UserStateExcludingUserFirstLoginPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
  override createDataModel(
    presenter: UserStateExcludingUserFirstLoginPresenterModel,
  ): UserStateDataEntryValueExcludingUserFirstLogin {
    const parser = this.getParser(
      UserStateDataEntryValueExcludingUserFirstLogin,
      UserStateExcludingUserFirstLoginPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
}
